export const getSelectedFormIndexItem = state => state.formIndex.find(formIndex => formIndex.id === state.selectedFormId);